
export const platform = {
  "title": "MSP Platform Admin",
  "subtitle": "Super Admin Console",
  "loading": "Retrieving Data...",
  "systemError": "System Error",
  "retry": "Retry",
  "tabs": {
      "overview": "Overview",
      "plans": "Plans",
      "marketing": "Marketing AI",
      "logs": "Security Logs",
      "diagnostics": "Diagnostics"
  },
  "stats": {
      "mrr": "Monthly Recurring Revenue",
      "stores": "Total Clinics",
      "patients": "Total Patients (Global)",
      "transactions": "Total Transactions"
  },
  "storeTable": {
      "title": "Clinic Management",
      "name": "Clinic Name",
      "plan": "Plan",
      "wallet": "Wallet",
      "status": "Status",
      "action": "Manage",
      "searchPlaceholder": "Search stores..."
  },
  "tools": {
      "backup": "Database Backup",
      "backupDesc": "Generate a full backup of the public schema.",
      "downloadBackup": "Download Backup",
      "reconcile": "Reconcile Payment",
      "reconcileDesc": "Manually check payment status.",
      "check": "Check"
  }
};
